import { api } from "../lib/api";
import type { OnboardingAnswers } from "../types/onboarding";

export async function saveOnboardingField(
	field: string,
	value: string | number | string[],
): Promise<void> {
	try {
		await api.post("/api/user/save-onboarding-field", { field, value });
	} catch (error: unknown) {
		if (error && typeof error === "object" && "response" in error) {
			const axiosError = error as { response?: { data?: { error?: string } } };
			if (axiosError.response?.data?.error) {
				throw new Error(axiosError.response.data.error);
			}
		}
		throw new Error("Failed to save onboarding field");
	}
}

export async function saveOnboardingFields(
	fields: OnboardingAnswers,
): Promise<void> {
	try {
		await api.post("/api/user/save-onboarding-fields", { fields });
	} catch (error: unknown) {
		if (error && typeof error === "object" && "response" in error) {
			const axiosError = error as { response?: { data?: { error?: string } } };
			if (axiosError.response?.data?.error) {
				throw new Error(axiosError.response.data.error);
			}
		}
		throw new Error("Failed to save onboarding fields");
	}
}

export async function completeOnboarding(
	answers: OnboardingAnswers,
): Promise<void> {
	try {
		await api.post("/api/complete-onboarding", answers);
	} catch (error: unknown) {
		if (error && typeof error === "object" && "response" in error) {
			const axiosError = error as { response?: { data?: { error?: string } } };
			if (axiosError.response?.data?.error) {
				throw new Error(axiosError.response.data.error);
			}
		}
		throw new Error("Failed to complete onboarding");
	}
}

export async function skipOnboarding(): Promise<void> {
	try {
		await api.post("/api/user/skip-onboarding");
	} catch (error: unknown) {
		if (error && typeof error === "object" && "response" in error) {
			const axiosError = error as { response?: { data?: { error?: string } } };
			if (axiosError.response?.data?.error) {
				throw new Error(axiosError.response.data.error);
			}
		}
		throw new Error("Failed to skip onboarding");
	}
}
